import React from 'react';

import {Sublabel} from 'ui-library/Headers';
import AddIcon from 'ui-library/icons/AddIcon';

interface ReviewCriteriaGroupHeaderProps {
  onAddCriterion: (() => void) | null; // If specified, renders a plus button
  renderControls?: () => boolean | JSX.Element;
  renderGroupName: () => string | JSX.Element;
  shouldRenderPassFail: boolean;
}

export default function ReviewCriteriaGroupHeader(props: ReviewCriteriaGroupHeaderProps): JSX.Element {
  return (
    <div className="simpleDivTable-header">
      <div className="simpleDivTable-headerCell">
        <div className="u-spacing-bottom">{props.renderGroupName()}</div>
        <div className="checkableCriterionRow-container">
          {props.shouldRenderPassFail && (
            <div className="checkableCriterionRow-passFail">
              <Sublabel>Pass</Sublabel>
            </div>
          )}
          {props.shouldRenderPassFail && (
            <div className="checkableCriterionRow-passFail u-small-spacing-right">
              <Sublabel>Fail</Sublabel>
            </div>
          )}
          <div className="checkableCriterionRow-text">
            <Sublabel>Criteria {props.onAddCriterion && <AddIcon onClick={props.onAddCriterion} />}</Sublabel>
          </div>
        </div>
      </div>
      <div className="simpleDivTable-headerCell u-text-align-right">
        {props.renderControls && props.renderControls()}
      </div>
    </div>
  );
}

ReviewCriteriaGroupHeader.defaultProps = {
  shouldRenderPassFail: true,
};
